import {
  Badge,
  Button,
  Card,
  Input,
  message,
  Popover,
  Select,
  Space,
  Table,
  Tag,
  Tooltip,
  Typography,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { CardSchema } from '../../types/cards/card-types';
import {
  FetchNextPageOptions,
  InfiniteQueryObserverResult,
} from '@tanstack/react-query';
import { formatDate } from '../../utils/format';
import { ColumnsType } from 'antd/es/table';
import {
  EllipsisOutlined,
  EyeOutlined,
  FilterOutlined,
  PlusCircleFilled,
  ShoppingCartOutlined,
} from '@ant-design/icons';
import InfiniteLoaderWrapper from '../InfiniteLoaderWrapper';
import CardDetailsModal from './CardDetailsModal';
import useDispatchACard from '@/hooks/cards/useDispatchACard';
import { renderStatus } from '@/utils/card-utils';

type TCardDataProps = {
  cardData: CardSchema[];
  fetchNextPage: (
    options?: FetchNextPageOptions
  ) => Promise<InfiniteQueryObserverResult<any[], Error>>;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  isTableLoading: boolean;
};

function CardsPhysicalCardsTable(props: TCardDataProps) {
  const [cardDetails, setCardDetails] = useState<CardSchema | null>(null);
  const [viewCardDetails, setViewCardDetails] = useState<boolean>(false);

  const { mutate: mutateDispatchCard, isPending: isPendingDispatchCard } =
    useDispatchACard();

  // const onHandleDispatchCard = (cardId: string) => {
  //   mutateDispatchCard(
  //     { card_id: cardId },
  //     {
  //       onSuccess: () => {
  //         message.success('Card dispatched successfully');
  //       },
  //     }
  //   );
  // };
  // Table columns

  const allCardsColumn: ColumnsType<CardSchema> = [
    {
      title: 'Card Number',
      key: 'card_number',
      width: 180,
      render: (_: unknown, record: CardSchema) => (
        <Space>
          <span><Tag>{record.bin}</Tag> •••• {record.last_four}</span>
        </Space>
      ),
    },
    {
      title: 'Holder',
      dataIndex: 'holder_name',
      key: 'holder_name',
      width: 200,
    },
    {
      title: 'Brand',
      dataIndex: 'brand',
      key: 'brand',
      width: 120,
      render: (brand: string) => <Tag color='blue'>{brand}</Tag>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      render: renderStatus,
    },
    {
      title: 'Created',
      dataIndex: 'created',
      key: 'created',
      width: 150,
      render: (date: string) => formatDate(date),
    },
  ];

  const {
    cardData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isTableLoading,
  } = props;
  const [searchValue, setSearchValue] = useState<string>('');
  const [filteredData, setFilteredData] = useState<CardSchema[]>([]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);

    // Filter card item based on the search value
    const filteredData = cardData.filter((item) =>
      item.holder_name.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setFilteredData(filteredData);
  };

  useEffect(() => {
    if (cardData) {
      setFilteredData(cardData);
    }
  }, [cardData]);

  return (
    <>
      <Card
        title={
          <Space>
            <Typography.Title level={5}>Physical Cards</Typography.Title>
          </Space>
        }
        style={{ marginTop: 24 }}
        extra={
          <Space>
            <Input
              placeholder='Search by name'
              value={searchValue}
              onChange={handleChange}
              style={{ width: '100%' }}
            />
          </Space>
        }
      >
        <InfiniteLoaderWrapper
          hasNextPage={hasNextPage}
          fetchNextPage={fetchNextPage}
          isFetchingNextPage={isFetchingNextPage}
        >
          <Table
            dataSource={filteredData}
            columns={allCardsColumn}
            rowKey='id'
            pagination={false}
            loading={isTableLoading}
          />
        </InfiniteLoaderWrapper>
      </Card>

      <CardDetailsModal
        isModalVisible={viewCardDetails}
        setIsModalVisible={setViewCardDetails}
        cardData={cardDetails!}
      />
    </>
  );
}

export default CardsPhysicalCardsTable;
